// Contenido para birthday-particles.js
document.addEventListener('DOMContentLoaded', function() {
  const fallingEmojis = ['🎂', '🥳', '🎊']; 
  const container = document.body;
  const particlesCount = 30; // Número de emojis en pantalla

  for (let i = 0; i < particlesCount; i++) {
    let particle = document.createElement('span');
    particle.classList.add('falling-particle');
    particle.style.left = Math.random() * 100 + 'vw';
    particle.style.animationDuration = (Math.random() * 3) + 4 + 's'; // Duración de la caída entre 2 y 5 segundos
    particle.style.animationDelay = Math.random() * 10 + 's';
    particle.style.fontSize = Math.floor(Math.random() * 10) + 25 + 'px'; // Tamaño del emoji
    particle.textContent = fallingEmojis[Math.floor(Math.random() * fallingEmojis.length)];
    container.appendChild(particle);
  }
});